<template>
  <ul class="nav">
    <li
      class="nav-item"
      v-b-tooltip.hover
      :title="'Clique para voltar ao Menu Principal'"
    >
      <div
        class="nav-link"
        exact
        v-on:click="$emit('BackMenu')"
      >
        <i class="ico icon-arrow-left"></i> {{ $lang.Menu.Common.MainManeu }}
      </div>
    </li>
    <li class="nav-title text-muted">ACESSOS</li>
    <li
      class="nav-item"
      v-if="hasRole(roles.CRIAR_USUARIO)"
    >
      <router-link
        :to="{ name: 'Contas' }"
        class="nav-link"
        exact
      >
        <i class="fas fa-user-shield"></i> Usuários
      </router-link>
    </li>
    <li
      class="nav-item"
      v-if="hasRole(roles.ADMINISTRADOR)"
    >
      <router-link
        :to="{ name: 'Grupo' }"
        class="nav-link"
        exact
      >
        <i class="fas fa-users"></i> Grupos
      </router-link>
    </li>
    <li class="nav-title text-muted">CADASTROS</li>
    <router-link
      v-if="hasRole(roles.ADMINISTRADOR)"
      tag="li"
      class="nav-item nav-dropdown"
      :to="{ path: '/cadastro/organizacao/' }"
      disabled
    >
      <div
        class="nav-link nav-dropdown-toggle"
        @click="handleClick"
      >
        <i class="fas fa-building"></i> Organização
      </div>
      <ul class="nav-dropdown-items">
        <li class="nav-item">
          <router-link
            :to="{ name: 'Pessoa' }"
            class="nav-link"
            exact
          >
            <i class="fas fa-user"></i> Pessoas
          </router-link>
        </li>
        <li
          class="nav-item"
          v-if="modules.hasAssociado"
        >
          <router-link
            :to="{ name: 'Associado' }"
            class="nav-link"
            exact
          >
            <i class="fas fa-user-alt"></i> Associado
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'Funcionarios' }"
            class="nav-link"
            exact
          >
            <i class="fas fa-user-tie"></i> Funcionários
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'Cargos' }"
            class="nav-link"
            exact
          >
            <i class="fas fa-sitemap"></i> Cargos
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'Regional' }"
            class="nav-link"
            exact
          >
            <i class="fas fa-store-alt"></i> Regionais
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'PA' }"
            class="nav-link"
            exact
          >
            <i class="fas fa-university"></i> PA
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'Cluster' }"
            class="nav-link"
            exact
          >
            <i class="fas fa-briefcase"></i> Clusterização
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'EmailEnvio' }"
            class="nav-link"
            exact
          >
            <i class="fas fa-envelope"></i> Emails
          </router-link>
        </li>
      </ul>
    </router-link>

    <router-link
      tag="li"
      class="nav-item nav-dropdown"
      :to="{ path: '/configuracao' }"
      disabled
      v-if="hasRole(roles.ADMINISTRADOR)"
    >
      <div
        class="nav-link nav-dropdown-toggle"
        @click="handleClick"
      >
        <i class="fas fa-id-card"></i> Follow up
      </div>
      <ul class="nav-dropdown-items">
        <li class="nav-item">
          <router-link
            :to="{ name: 'TipoEvento' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Tipo de Eventos
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'Evento' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Eventos
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'TipoDespesa' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Tipo de Despesas
          </router-link>
        </li>
      </ul>
    </router-link>
    <router-link
      tag="li"
      class="nav-item nav-dropdown"
      :to="{ path: '/cadastro/quadro/' }"
      disabled
      v-if="hasRole(roles.ADMINISTRADOR) && hasModuleKanban"
    >
      <div
        class="nav-link nav-dropdown-toggle"
        @click="handleClick"
      >
        <i class="fas fa-columns"></i> Quadro
      </div>
      <ul class="nav-dropdown-items">
        <li class="nav-item">
          <router-link
            :to="{ name: 'OrigemLead' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Origem do Lead
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'Motivo' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Motivo
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'Produto' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Produto
          </router-link>
        </li>
      </ul>
    </router-link>

    <router-link
      tag="li"
      class="nav-item nav-dropdown"
      :to="{ path: '/campanha/' }"
      disabled
      v-if="hasRole(roles.ADMINISTRADOR) || hasRole(roles.ACESSO_CAMPANHA)"
    >
      <div
        class="nav-link nav-dropdown-toggle"
        @click="handleClick"
      >
        <i class="fas fa-bullhorn"></i> Campanha
        <b-badge variant="primary">Novo</b-badge>
      </div>
      <ul class="nav-dropdown-items">
        <li class="nav-item">
          <router-link
            :to="{ name: 'CampanhaLista' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Listas
          </router-link>
        </li>
        <li
          class="nav-item"
          v-if="hasRole(roles.ADMINISTRADOR)"
        >
          <router-link
            :to="{ name: 'WhatsappConfig' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Whatsapp
          </router-link>
        </li>
      </ul>
    </router-link>

    <router-link
      v-if="hasRole(roles.ADMINISTRADOR)"
      tag="li"
      class="nav-item nav-dropdown"
      :to="{ path: '/cadastro/contatos' }"
      disabled
    >
      <div
        class="nav-link nav-dropdown-toggle"
        @click="handleClick"
      >
        <i class="fas fa-address-book"></i> Contatos
      </div>
      <ul class="nav-dropdown-items">
        <li class="nav-item">
          <router-link
            :to="{ name: 'ContatoExterno' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Externo
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'ContatoInterno' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Interno
          </router-link>
        </li>
      </ul>
    </router-link>

    <router-link
      tag="li"
      class="nav-item nav-dropdown"
      :to="{ path: '/cadastro/movimentacao' }"
      disabled
      v-if="hasRole(roles.MOVIMENTACAO) || hasRole(roles.ADMINISTRADOR)"
    >
      <div
        class="nav-link nav-dropdown-toggle"
        @click="handleClick"
      >
        <i class="fas fa-exchange-alt"></i> Movimentações
      </div>
      <ul class="nav-dropdown-items">
        <li class="nav-item">
          <router-link
            :to="{ name: 'LinkClusters' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Cluster
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'LinkGerenteRelacionamento' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i>
            {{ $lang.RelationchipManager.ShortLabel }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'ChangeMassGerenteRelacionamento' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Mudar
            {{ $lang.RelationchipManager.ShortLabel }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'GiroCarteira' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Giro de Carteira
          </router-link>
        </li>
      </ul>
    </router-link>

    <router-link
      tag="li"
      class="nav-item nav-dropdown"
      :to="{ path: '/cadastro/parametros' }"
      disabled
      v-if="hasRole(roles.ADMINISTRADOR)"
    >
      <div
        class="nav-link nav-dropdown-toggle"
        @click="handleClick"
      >
        <i class="fas fa-wrench"></i> Parâmetros
      </div>
      <ul class="nav-dropdown-items">
        <li class="nav-item">
          <router-link
            :to="{ name: 'ContaCapitalParametros' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Card Conta Capital
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'MetasGerente' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Metas
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'MovimentacaoConta' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Mov. da Conta
          </router-link>
        </li>
        <li class="nav-item" v-if="hasRole(roles.ADMINISTRADOR)">
          <router-link :to="{ name: 'EncurtadorConfig' }" class="nav-link" exact>
            <i class="fa fa-caret-right"></i> Encurtador
          </router-link>
        </li>
        <li
          class="nav-item"
          @click.prevent="toggleChild('relatorioVisitas__container')"
          v-if="modules.hasVisitas"
        >
          <div class="nav-link">
            <i
              class="fa fa-caret-right caret-direction-relatorioVisitas__container"
            ></i>
            Visitas
          </div>
        </li>
        <div
          class="relatorioVisitas__container d-none"
          v-if="modules.hasVisitas"
        >
          <li class="nav-item">
            <router-link
              :to="{ name: 'AberturaDeCardVisitas' }"
              class="nav-link deep-item"
              exact
              ><i class="fa fa-caret-right"></i> Abertura de CARD</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'TipoTransporte' }"
              class="nav-link deep-item"
              exact
              ><i class="fa fa-caret-right"></i> Tipo/Valor de
              Transporte</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'TiposVisitas' }"
              class="nav-link deep-item"
              exact
              ><i class="fa fa-caret-right"></i> Tipos Visitas</router-link
            >
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'VisitasHodometro' }"
              class="nav-link deep-item"
              exact
              ><i class="fa fa-caret-right"></i> Hodômetro</router-link
            >
          </li>
        </div>
      </ul>
    </router-link>

    <router-link
      tag="li"
      class="nav-item nav-dropdown"
      :to="{ path: '/cadastro/parametros_atendimento' }"
      disabled
      v-if="hasAtendimento && (hasRole('OPERADOR_ATENDIMENTO') || hasRole(roles.ADMINISTRADOR))"
    >
      <div class="nav-link nav-dropdown-toggle " @click="handleClick">
        <i class="fas fa-wrench"></i> Parâmetros Atendimento
      </div>
      <ul class="nav-dropdown-items">
        <li class="nav-item">
          <router-link
            :to="{ name: 'ParametrosFinalizacao' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Tipos de finalização
          </router-link>
          <router-link
            :to="{ name: 'HorarioAtendimento' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Horário de Atendimento
          </router-link>
          <router-link
            :to="{ name: 'MensagensAutomaticas' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Mensagens Automáticas
          </router-link>
          <router-link
            :to="{ name: 'RegistroBot' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Registro de Bots
          </router-link>
          <router-link
            :to="{ name: 'Provedor' }"
            class="nav-link"
            exact >
            <i class="fa fa-caret-right"></i> Provedor
          </router-link>
        </li>
      </ul>
    </router-link>

    <router-link
      tag="li"
      class="nav-item nav-dropdown"
      :to="{ path: '/cadastro/api' }"
      disabled
      v-if="hasRole(roles.ADMINISTRADOR)"
    >
      <div
        class="nav-link nav-dropdown-toggle"
        @click="handleClick"
      >
        <i class="fas fa-tools"></i> Menu API
      </div>
      <ul class="nav-dropdown-items">
        <li class="nav-item">
          <router-link
            :to="{ name: 'ClasseAParametros' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Classe A
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'SerasaParams' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Serasa
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'ViewbParametros' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Viewb
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'WhatsappParams' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> WhatsApp
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'ActiveDirectory' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Active Directory (AD)
          </router-link>
        </li>
      </ul>
    </router-link>

    <router-link
      tag="li"
      class="nav-item nav-dropdown"
      :to="{ path: '/cadastro/ajuizamento/' }"
      v-if="hasRole(roles.ADMINISTRADOR) && modules.hasAjuizamento"
    >
      <div
        class="nav-link nav-dropdown-toggle"
        @click="handleClick"
      >
        <i class="fas fa-balance-scale"></i> Ajuizamento
      </div>
      <ul class="nav-dropdown-items">
        <li class="nav-item">
          <router-link
            :to="{ name: 'Advogado' }"
            class="nav-link"
            exact
            ><i class="fa fa-caret-right"></i> Advogado</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'Assunto' }"
            class="nav-link"
            exact
            ><i class="fa fa-caret-right"></i> Assunto</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'Comarca' }"
            class="nav-link"
            exact
            ><i class="fa fa-caret-right"></i> Comarca</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'Fase' }"
            class="nav-link"
            exact
            ><i class="fa fa-caret-right"></i> Fase</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'ObjetoAcao' }"
            class="nav-link"
            exact
            ><i class="fa fa-caret-right"></i> Objeto da Ação</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'Prognostico' }"
            class="nav-link"
            exact
            ><i class="fa fa-caret-right"></i> Prognóstico</router-link
          >
        </li>
      </ul>
    </router-link>

    <router-link
      tag="li"
      class="nav-item nav-dropdown"
      :to="{ path: '/cadastro/nxSenhas/' }"
      v-if="hasRole(roles.ADMINISTRADOR)"
    >
      <div
        class="nav-link nav-dropdown-toggle"
        @click="handleClick"
      >
        <i class="fas fa-id-badge"></i> Atendimento Senhas
      </div>
      <ul class="nav-dropdown-items">
        <li class="nav-item">
          <router-link
            :to="{ name: 'Categoria' }"
            class="nav-link"
            exact
            ><i class="fa fa-caret-right"></i> Categoria de Atendimento</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'Mesa' }"
            class="nav-link"
            exact
            ><i class="fa fa-caret-right"></i> Mesa de atendimento</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'RegistroTotem' }"
            class="nav-link"
            exact
            ><i class="fa fa-caret-right"></i> Usuário Totem</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'RegistroTv' }"
            class="nav-link"
            exact
            ><i class="fa fa-caret-right"></i> Usuário Tv</router-link
          >
        </li>
      </ul>
    </router-link>

    <li
      class="nav-item"
      v-if="hasRole(roles.ADMINISTRADOR) && modules.hasListaInteligente"
    >
      <router-link
        :to="{ name: 'ListaInteligente' }"
        class="nav-link"
        exact
      >
        <i class="fas fa-clipboard-list"></i> Listas Inteligentes
      </router-link>
    </li>
    <router-link
      tag="li"
      class="nav-item nav-dropdown"
      :to="{ path: '/cadastro/modelos' }"
      disabled
      v-if="hasRole(roles.ADMINISTRADOR) || hasRole(roles.ACESSO_CAMPANHA)"
    >
      <div
        class="nav-link nav-dropdown-toggle"
        @click="handleClick"
      >
        <i class="fab fa-buromobelexperte"></i> Modelos
      </div>
      <ul class="nav-dropdown-items">
        <li class="nav-item">
          <router-link
            :to="{ name: 'CampanhaModelo' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> Campanha
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'Hsm' }"
            class="nav-link"
            exact
          >
            <i class="fa fa-caret-right"></i> HSM
          </router-link>
        </li>
      </ul>
    </router-link>

    <li
      class="nav-item"
      v-if="hasRole(roles.ADMINISTRADOR)"
    >
      <router-link
        :to="{ name: 'Links' }"
        class="nav-link"
        exact
      >
        <i class="fas fa-link"></i> Atalhos
      </router-link>
    </li>
  </ul>
</template>

<script>
import ModulesLite from '@/shared/mixins/modulesLite'
import Roles from '@/shared/utils/roles.js'
// import PermissionMixin from '@/store/module/permission/mixin'
import { JWTService } from '@/shared/services/jwt'

export default {
  name: 'SidebarSetting',
  mixins: [ModulesLite],
  data () {
    return {
      roles: Roles,
      permissions: null,
      hasModuleKanban: process.env.hasKanban,
      hasAtendimento: process.env.hasAtendimento,
      visitas__container: false
    }
  },
  mounted () {
    this.permissions = JWTService.GetRoles()
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.stopPropagation()

      const current = e.target.closest('.nav-dropdown')
      if (!current) return

      const submenu = current.querySelector('.nav-dropdown-items')
      const isOpen = current.classList.contains('open')

      const siblings = current.parentElement.children
      for (let element of siblings) {
        if (element !== current && element.classList.contains('open')) {
          element.classList.remove('open')
          const sub = element.querySelector('.nav-dropdown-items')
          if (sub) {
            sub.style.maxHeight = ''
            sub.style.overflowY = ''
          }
        }
      }

      if (isOpen) {
        current.classList.remove('open')
        if (submenu) {
          submenu.style.maxHeight = ''
          submenu.style.overflowY = ''
        }
      } else {
        current.classList.add('open')
        if (submenu) {
          if (submenu.scrollHeight > 216) {
            submenu.style.maxHeight = '216px'
            submenu.style.overflowY = 'auto'
          } else {
            submenu.style.maxHeight = ''
            submenu.style.overflowY = ''
          }
        }
      }
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          // if (this.permissions[i].role === role) {
          if (this.permissions[i] === role) {
            result = true
          }
        }
      }
      return result
    },
    toggleChild (e) {
      // e.preventDefault()
      document.querySelector('.' + e).classList.toggle('d-none')
      document
        .querySelector('.caret-direction-' + e)
        .classList.toggle('caret-direction-bottom')
    }
  }
}
</script>

<style lang="css">
.nav-link {
  cursor: pointer;
}
.deep-item {
  margin-left: 1rem !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.caret-direction-bottom {
  transition: transform 0.15s ease-in-out;
  transform: rotate(90deg);
}
.nav-dropdown-toggle:hover,
.nav-dropdown:hover {
  right: 50;
}
</style>



// WEBPACK FOOTER //
// src/containers/layout/sidebars/SidebarSettings.vue